export default "__VITE_ASSET__c303232a__"